import { inject, Injectable } from '@angular/core';
import { combineLatest, firstValueFrom, Observable, of } from 'rxjs';
import { OpenNewDepartmentPopup } from '../components/detail-views/detail-employee/employee-helper';
import { Actions, ofType } from '@ngrx/effects';
import { DepartmentActions } from '../dave-data-module/State/actions/department.actions';
import { CustomLabelService } from '../services/custom-label/custom-label.service';
import { Store } from '@ngrx/store';
import { State } from '../dave-data-module/State';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { PartnerOfficeResolver } from '../dave-data-module/guards/partner-office.resolver';
import { EmployeeResolver } from '../dave-data-module/guards/employee.resolver';
import { DepartmentResolver } from '../dave-data-module/guards/department.resolver';
import { DepartmentEntity } from '../dave-data-module/entities/department.entity';
import { getDepartmentById, getDepartmentsActive } from '../dave-data-module/State/selectors/department.selector';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

    private cls = inject(CustomLabelService);
    private store = inject(Store<State>);
    private dialog = inject(MatLegacyDialog);
    private actions$ = inject(Actions);

    private partnerOfficeResolver = inject(PartnerOfficeResolver);
    private employeeResolver = inject(EmployeeResolver);
    private departmentsResolver = inject(DepartmentResolver);


  constructor() { }

    selectOptions$(requiredId$?: Observable<number | null>, partnerOfficeFilter$?: Observable<number | null>): Observable<DepartmentEntity[]> {
        return combineLatest([
            this.store.select(getDepartmentsActive),
            requiredId$ ? requiredId$.pipe(switchMap((DepartmentId) => DepartmentId ? this.store.select(getDepartmentById({id: DepartmentId})) : of(null))) : of(null),
            partnerOfficeFilter$ ? partnerOfficeFilter$ : of(null),
        ]).pipe(map(([departments, selectedDepartment, partnerOfficeId]) => {
            const _departments = partnerOfficeId ? departments.filter(({PartnerOfficeId}) => PartnerOfficeId === partnerOfficeId) : departments;

            if (selectedDepartment && _departments.every((t) => t.Id !== selectedDepartment.Id)) {
                return [..._departments, selectedDepartment];
            } else {
                return _departments;
            }
        }));
    }

    async addDialog(): Promise<null | DepartmentEntity> {
        const label = await firstValueFrom(this.cls.getSingle$('Department'))

        const submitted = await OpenNewDepartmentPopup(this.dialog, this.store, label, this.partnerOfficeResolver, this.employeeResolver, this.departmentsResolver)
        if (submitted) {
            const action = await firstValueFrom(this.actions$.pipe(ofType(DepartmentActions.addSuccess, DepartmentActions.addFailure)));
            if (action.type === DepartmentActions.addSuccess.type) {
                return action.Payload;
            }
        }
        return null;
    }
}
